// Cart sections are replaced after quantity changes. A custom element also
// upgrades images inserted later into the drawer or cart notification.
if (!customElements.get('studio-cart-model-image')) {
  customElements.define('studio-cart-model-image', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.controller?.abort();
      clearTimeout(this.timer);
      this.controller=new AbortController();
      this.attempts=0;this.failures=0;
      this.check(this.controller);
    }
    disconnectedCallback() {
      this.controller?.abort();
      clearTimeout(this.timer);
      this.preload?.removeAttribute('src');
    }
    async check(controller) {
      const current=()=>this.isConnected && this.controller===controller && !controller.signal.aborted;
      const image=this.querySelector('img');
      if (!image || !current() || ++this.attempts>200) return;
      try {
        const response=await fetch(this.dataset.statusUrl,{
          credentials:'omit',cache:'no-store',
          signal:AbortSignal.any([controller.signal,AbortSignal.timeout(10000)]),
        });
        if (!response.ok) throw new Error('Photo status unavailable');
        const result=await response.json();
        if (!current()) return;
        const url=result.images?.[this.dataset.photoView];
        if (result.state==='succeeded' && url) {
          const photo=new Image();this.preload=photo;
          photo.src=new URL(url,this.dataset.statusUrl).href;
          await photo.decode();
          if (!current()) return;
          image.src=photo.src;
          image.alt=`Your custom model in a ${this.dataset.photoView==='table_black' ? 'black' : 'white'} frame — view saved model`;
          image.height=Math.ceil(image.width*4/3);
          image.style.aspectRatio='3 / 4';
          this.ready=true;this.preload=null;
          return;
        }
        if (!['queued','running'].includes(result.state)) return;
        this.failures=0;
      } catch {
        // Keep the clean preview if the render, image, or network is unavailable.
        if (!current() || ++this.failures>=3) return;
      }
      if (current()) this.timer=setTimeout(()=>this.check(controller),1500);
    }
  });
}
